<template>
  <div class="file-uploader_box">
    <input type="file" id="imageFile_name" @change="onFileChange"/>

    <div v-for="(documentUrl, index) in documentUrls" :key="index">
      <p class="bold_label">{{documentUrl.name}}</p>
      <button @click="deleteFile(index)" class="active-rectangle_button">削除</button>
    </div>
  </div>
</template>

<script>
  import firebase from "firebase";
  import logging from "@/assets/js/functions/_core/logging";
  import store from "@/store";
  import {mapGetters} from "vuex";

  export default {
    name: "FileUploaderBox",

    data() {
      return {
        targetFile: '',
      }
    },

    mixins: [logging],

    props: {
      documentUrls: {
        type: Array,
        required: true
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),
    },

    methods: {
      onFileChange(event) {
        const files = event.target.files || event.dataTransfer.files;
        this.targetFile = files[0];
        this.uploadFile();
      },

      uploadFile() {
        store.dispatch('cover/toggleLoadCover');
        const storageRef = firebase.storage().ref();
        const fileRef = storageRef.child(`works/${this.uid}/${this.targetFile.name}`);

        fileRef.put(this.targetFile).then(snapshot => {
          snapshot.ref.getDownloadURL().then(downloadURL => {
            this.documentUrls.push({url: downloadURL, name: this.targetFile.name});
            document.getElementById("imageFile_name").value = "";
            store.dispatch('cover/toggleLoadCover');
          }).catch(error => {
            store.dispatch('cover/toggleLoadCover');
            this.logger(error, "ファイルの追加に失敗しました。");
          });
        }).catch(error => {
          store.dispatch('cover/toggleLoadCover');
          this.logger(error, "ファイルのアップロードに失敗しました。");
        });
      },

      deleteFile(index) {
        this.targetFile = '';
        this.$emit('deleteDocumentUrl', index);
      }
    }
  }
</script>


<style lang="scss" scoped>
  .file-uploader_box {
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 2rem;
    }
  }
</style>